import client from "../client";

export function getInterviewStepTypes() {
  return client.get("/api/v2/interview_step_types");
}
